import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import {
  Search,
  RegistrationStatus,
} from '../../../features/account-management/components/filters';
import { AccountTable } from '../../../features/account-management/components';
import { accountRoles, accountRolesT } from '../../../common/enums';

const { Group: CheckboxGroup } = Checkbox;

@translate()
export default class AccountList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterRoleChange: PropTypes.func.isRequired,
    onCreateNewHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  render() {
    const {
      accounts,
      pagination,
      filter,
      onTableChange,
      onFilterRoleChange,
      onFilterSearchChange,
      onCreateNewHandler,
      isLoading,
      t,
    } = this.props;

    const rolesFilterOptions = [
      { label: accountRolesT.ADMINISTRATOR, value: accountRoles.ADMINISTRATOR },
      { label: accountRolesT.OPERATOR, value: accountRoles.OPERATOR },
      { label: accountRolesT.CALL_CENTRUM, value: accountRoles.CALL_CENTRUM },
    ];

    return (
      <div>
        <h1>{t('Administrátori')}</h1>

        <Row className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="administratorSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
          <Col xs={12} sm={4} className="text-center">
            <CheckboxGroup options={rolesFilterOptions} value={filter.role} onChange={onFilterRoleChange} />
          </Col>
          <Col xs={12} sm={4} className="text-right">
            <Button onClick={onCreateNewHandler} size="small" type="primary">
              {t('Nový administrátor')}
            </Button>
          </Col>
        </Row>

        <AccountTable
          accounts={accounts}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/administrator-management/components/AdministratorList.js